import { render, staticRenderFns } from "./WorkOrderManagementNewAdd.vue?vue&type=template&id=12bdb3de"
import script from "./WorkOrderManagementNewAdd.vue?vue&type=script&lang=js"
export * from "./WorkOrderManagementNewAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports